import React, { useState } from "react";
import { Tabs } from "antd";

import { Modal } from "@components/Page";

import MobileVerificationRequest from "./MobileVerificationRequest";
import TotpSetup from "./TotpSetup";

const LABEL_TITLE = "Two Factor Authentication";
const LABEL_SMS = "SMS";
const LABEL_TOTP = "Authenticator App";
const SMS_METHOD = "SMS_MFA";
const TOTP_METHOD = "SOFTWARE_TOKEN_MFA";

type ModalControls = {
  open?: () => void;
}

type ModalRef = {
  current: ModalControls;
}

type Props = {
  modal: ModalRef;
  mobileNumber?: string;
  mfaMethods?: string[];
  isDisabled?: boolean;
  onSuccess: () => Promise<void> | void;
}

const TwoFactorAuthenticationModal = ({
  modal,
  mobileNumber,
  mfaMethods = [],
  isDisabled = false,
  onSuccess,
}: Props) => {
  const [ isOpen, setIsOpen ] = useState(false);
  const [ tabsRenderKey, setTabsRenderKey ] = useState(0);
  
  const hasSmsMethod = mfaMethods.includes(SMS_METHOD);
  const hasTotpMethod = mfaMethods.includes(TOTP_METHOD);
  
  const initialMethod = hasTotpMethod && !hasSmsMethod
    ? TOTP_METHOD
    : SMS_METHOD;
  
  const [ selectedMethod, setSelectedMethod ] = useState(initialMethod);

  modal.current.open = () =>
    setIsOpen(true);

  const onClose = () => {
    setTabsRenderKey((renderKey) => renderKey + 1);
    setIsOpen(false);
  };

  const onActivateSuccess = async () => {
    await onSuccess();
    onClose();
  };

  const tabsItems = [
    {
      key: SMS_METHOD,
      label: LABEL_SMS,
      disabled: isDisabled,
      children: (
        <MobileVerificationRequest
          mobileNumber={mobileNumber}
          onSuccess={onActivateSuccess}
        />
      ),
    },
    {
      key: TOTP_METHOD,
      label: LABEL_TOTP,
      disabled: isDisabled,
      children: (
        <TotpSetup onSuccess={onActivateSuccess} />
      ),
    },
  ];

  return (
    <Modal
      modal={modal}
      title={LABEL_TITLE}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Tabs
        key={tabsRenderKey}
        items={tabsItems}
        onChange={setSelectedMethod}
        activeKey={selectedMethod}
      />
    </Modal>
  );
};

export default TwoFactorAuthenticationModal;
